import { IMachineIcon } from 'interfaces/maps.interface';

import { iconsMap } from 'sharedMapComponents/MarkerUnit/constants';
export const DRY_PATH_COLOR = 'yellow';
export const POLYGON_COLOR = '#90caf9';
export const PARKING_COLOR = '#063831';
export const STANDING_EVENT_COLOR = '#c71010';
export const LIVE_MACHINES_REFRESH_TIME = 60000;
export const TIMELINE_COLORS = {
	DRY_PATH_COLOR,
	POLYGON_COLOR,
	PARKING_COLOR,
	STANDING_EVENT_COLOR,
};

export const selectedMapItemColor = 'red';
const ALERT_ICONS: Record<string, IMachineIcon> = {
	'TRIANGLE-RED': {
		url: iconsMap['TRIANGLE-RED'],
		iconType: 'TRIANGLE-RED',
		desc: 'THERE HAS BEEN AN ACCIDENT OR HIGH-G EVENT',
	},
	'CIRCLE-RED': {
		url: iconsMap['CIRCLE-RED'],
		iconType: 'CIRCLE-RED',
		desc: 'EXTERNAL POWER IS DISCONNECTED',
	},
	'SQUARE-RED': {
		url: iconsMap['SQUARE-RED'],
		iconType: 'SQUARE-RED',
		desc: 'EXTERNAL POWER IS DISCONNECTED FOR MORE THAN A DAY',
	},
	'ARROW-RED': {
		url: iconsMap['ARROW-RED'],
		iconType: 'ARROW-RED',
		desc: 'EXTERNAL POWER IS DISCONNECTED AND MACHINE IS MOVING',
	},
	'ARROW-YELLOW': {
		url: iconsMap['ARROW-YELLOW'],
		iconType: 'ARROW-YELLOW',
		desc: 'MACHINE IS MOVING WITH INTERNAL BATTERY BEING LOW',
	},
	'CIRCLE-YELLOW': {
		url: iconsMap['CIRCLE-YELLOW'],
		iconType: 'CIRCLE-YELLOW',
		desc: 'INTERNAL BATTERY IS LOW',
	},
	'CIRCLE-PINK': {
		url: iconsMap['CIRCLE-PINK'],
		iconType: 'CIRCLE-PINK',
		desc: 'ENGINE OFF',
	},
	'ARROW-BLUE': {
		url: iconsMap['ARROW-BLUE'],
		iconType: 'ARROW-BLUE',
		desc: 'MACHINE IS MOVING WITH SPRAYER ON',
	},
	'SQUARE-BLUE': {
		url: iconsMap['SQUARE-BLUE'],
		iconType: 'SQUARE-BLUE',
		desc: 'SPRAYER ON',
	},
	'ARROW-GREEN': {
		url: iconsMap['ARROW-GREEN'],
		iconType: 'ARROW-GREEN',
		desc: 'MACHINE IS MOVING',
	},
	'SQUARE-GREEN': {
		url: iconsMap['SQUARE-GREEN'],
		iconType: 'SQUARE-GREEN',
		desc: 'ENGINE ON',
	},
};

export const ALL_DRY_PATH_TAGS = {
	ACCIDENT_HIGH_G_FORCE: 'ACCIDENT_HIGH_G_FORCE',
	ACCIDENT_ROLLOVER: 'ACCIDENT_ROLLOVER',
	AVERAGE_SPEED: 'AVERAGE_SPEED',
	DISTANCE_TRAVELLED_METERS: 'DISTANCE_TRAVELLED_METERS',
	EXT_POWER_DISCONNECTED: 'EXT_POWER_DISCONNECTED',
	EXT_POWER_DISCONNECTED_WITH_MOVEMENT:
		'EXT_POWER_DISCONNECTED_WITH_MOVEMENT',
	EXT_POWER_DISCONNECTED_WITH_VIBRATION:
		'EXT_POWER_DISCONNECTED_WITH_VIBRATION',
	IGNITION_WIRE_TAMPERED: 'IGNITION_WIRE_TAMPERED',
	IGNITION_WIRE_TAMPERED_WITH_MOVEMENT:
		'IGNITION_WIRE_TAMPERED_WITH_MOVEMENT',
	INTERNAL_BATTERY_TAMPERED_PERCENTAGE:
		'INTERNAL_BATTERY_TAMPERED_PERCENTAGE',
	LOW_BATTERY_PERCENTAGE: 'LOW_BATTERY_PERCENTAGE',
	MAX_INTERNAL_TEMPERATURE: 'MAX_INTERNAL_TEMPERATURE',
	MAX_SPEED: 'MAX_SPEED',
	MIN_INTERNAL_TEMPERATURE: 'MIN_INTERNAL_TEMPERATURE',
	NETWORK_LOW_SIGNAL_STRENGTH: 'NETWORK_LOW_SIGNAL_STRENGTH',
	TOWING_MACHINE_TOWING: 'TOWING_MACHINE_TOWING',
	TagProperty_SEGMENT_TYPE: 'TagProperty_SEGMENT_TYPE',
	SEGMENT_NUMBER: 'SEGMENT_NUMBER',
};

export const DATE_FORMATS = {
	DATE_MONTH_YEAR: 'YYYYMMDD',
	DATE_MONTH_YEAR_AND_TIME: 'DD-MMM-YYYY hh:mm a',
};
export { ALERT_ICONS };
